export const CHANGE_LOGS: {
  [key in ChangeLogKeyType]: {
    title: string;
    headline: string;
    thumbnail: string;
    date: string;
  };
} = {
  'update_1.39.0': {
    title: '1.39.0 버전 업데이트 및 변경사항',
    headline: '더 짧아진 공유 링크, 커스텀 링크까지',
    thumbnail: '/images/updateLog/one_thirty_nine_zero.png',
    date: '2026. 09. 21. 월',
  },
  'update_1.38.0': {
    title: '1.38.0 버전 업데이트 및 변경사항',
    headline: '이메일 캠페인 베타 출시',
    thumbnail: '/images/updateLog/one_thirty_eight_zero.png',
    date: '2026. 08. 25. 화',
  },
  'update_1.37.0': {
    title: '1.37.0 버전 업데이트 및 변경사항',
    headline: 'PDF 뷰어 동영상 임베드 기능 지원',
    thumbnail: '/images/updateLog/one_thirty_seven_zero.png',
    date: '2026. 08. 07. 목',
  },
  'update_1.36.0': {
    title: '1.36.0 버전 업데이트 및 변경사항',
    headline: '고객 페이지에 새로운 리드 알림 추가',
    thumbnail: '/images/updateLog/one_thirty_six_zero.png',
    date: '2026. 07. 21. 화',
  },
  'update_1.35.0': {
    title: '1.35.0 버전 업데이트 및 변경사항',
    headline: '더 빠르고 편리해진 PDF 뷰어',
    thumbnail: '/images/updateLog/one_thirty_five_zero.png',
    date: '2026. 07. 13. 월',
  },
  'update_1.34.0': {
    title: '1.34.0 버전 업데이트 및 변경사항',
    headline: 'PDF·링크 QR 코드 보기',
    thumbnail: '/images/updateLog/one_thirty_four_zero.png',
    date: '2026. 06. 23. 화',
  },
  'update_1.33.0': {
    title: '1.33.0 버전 업데이트 및 변경사항',
    headline: 'PDF 웹 뷰어 콘텐츠 보호',
    thumbnail: '/images/updateLog/one_thirty_three_zero.png',
    date: '2026. 06. 19. 금',
  },
  'update_1.32.0': {
    title: '1.32.0 버전 업데이트 및 변경사항',
    headline: '링크 미리보기 브랜드 커스터마이징',
    thumbnail: '/images/updateLog/one_thirty_two_zero.png',
    date: '2026. 05. 27. 수',
  },
  'update_1.31.0': {
    title: '1.31.0 버전 업데이트 및 변경사항',
    headline: '링크 대량발송용 지원',
    thumbnail: '/images/updateLog/one_thirty_one_zero.png',
    date: '2026. 05. 14. 목',
  },
  'update_1.30.0': {
    title: '1.30.0 버전 업데이트 및 변경사항',
    headline: 'PDF 대량발송용 파일 고객 연동 지원',
    thumbnail: '/images/updateLog/one_thirty_zero.png',
    date: '2026. 05. 09. 토',
  },
  'update_1.29.0': {
    title: '1.29.0 버전 업데이트 및 변경사항',
    headline: 'PDF 뷰어 열람 UTM 수집 및 조회 기능 추가',
    thumbnail: '/images/updateLog/one_twenty_nine_zero.png',
    date: '2026. 05. 03. 일',
  },
  'update_1.28.0': {
    title: '1.28.0 버전 업데이트 및 변경사항',
    headline: '문의양식 전체 동의 기능 추가',
    thumbnail: '/images/updateLog/one_twenty_eight_zero.png',
    date: '2026. 04. 28. 화',
  },
  'update_1.27.0': {
    title: '1.27.0 버전 업데이트 및 변경사항',
    headline: '봇 탐지 및 필터링 기능 지원',
    thumbnail: '/images/updateLog/one_twenty_seven_zero.png',
    date: '2026. 04. 12. 일',
  },
  'update_1.26.0': {
    title: '1.26.0 버전 업데이트 및 변경사항',
    headline: '대용량 PDF 업로드 지원',
    thumbnail: '/images/updateLog/one_twenty_six_zero.png',
    date: '2026. 03. 10. 화',
  },
  'update_1.25.0': {
    title: '1.25.0 버전 업데이트 및 변경사항',
    headline: '실시간 슬랙 알림 지원',
    thumbnail: '/images/updateLog/one_twenty_five_zero.png',
    date: '2026. 01. 29. 목',
  },
  'update_1.24.0': {
    title: '1.24.0 버전 업데이트 및 변경사항',
    headline: '전체 열람 통계에 유입 경로 통계 추가',
    thumbnail: '/images/updateLog/one_twenty_four_zero.png',
    date: '2026. 01. 14. 수',
  },
  'update_1.23.0': {
    title: '1.23.0 버전 업데이트 및 변경사항',
    headline: '유입 경로까지 확인되는 리드 열람 분석',
    thumbnail: '/images/updateLog/one_twenty_three_zero.png',
    date: '2026. 01. 08. 목',
  },
  'update_1.22.0': {
    title: '1.22.0 버전 업데이트 및 변경사항',
    headline: 'PDF 업로드 기능 개선',
    thumbnail: '/images/updateLog/one_twenty_two_zero.png',
    date: '2025. 11. 19. 수',
  },
  'update_1.21.0': {
    title: '1.21.0 버전 업데이트 및 변경사항',
    headline: '뷰어 링크 안정성 및 UX 개선',
    thumbnail: '/images/updateLog/one_twenty_one.png',
    date: '2025. 10. 28. 화',
  },
  'update_1.20.0': {
    title: '1.20.0 버전 업데이트 및 변경사항',
    headline: 'PDF 웹 뷰어에서 내부 페이지 이동 하이퍼링크 지원',
    thumbnail: '/images/updateLog/one_twenty_zero.png',
    date: '2025. 10. 22. 수',
  },
  'update_1.19.0': {
    title: '1.19.0 버전 업데이트 및 변경사항',
    headline: '문의양식 이메일 인증 기능 추가',
    thumbnail: '/images/updateLog/one_nineteen_zero.png',
    date: '2025. 09. 09. 화',
  },
  'update_1.18.0': {
    title: '1.18.0 버전 업데이트 및 변경사항',
    headline: '세일즈클루 뷰어 UI 다국어 지원 확대',
    thumbnail: '/images/updateLog/one_eighteen_zero.png',
    date: '2025. 08. 13. 수',
  },
  'update_1.17.0': {
    title: '1.17.0 버전 업데이트 및 변경사항',
    headline: '전체 열람 통계에 국가 통계 추가',
    thumbnail: '/images/updateLog/one_seventeen_zero.png',
    date: '2025. 08. 08. 금',
  },
  'update_1.16.0': {
    title: '1.16.0 버전 업데이트 및 변경사항',
    headline: '열람인의 국가·도시 정보 확인',
    thumbnail: '/images/updateLog/one_sixteen_zero.png',
    date: '2025. 08. 01. 금',
  },
  'update_1.15.0': {
    title: '1.15.0 버전 업데이트 및 변경사항',
    headline: '열람/문의양식(폼) 제출 알림 설정 분리',
    thumbnail: '/images/updateLog/one_fifteen_zero.png',
    date: '2025. 07. 16. 수',
  },
  'update_1.14.0': {
    title: '1.14.0 버전 업데이트 및 변경사항',
    headline: '실시간 열람 알림 설정 기능 추가',
    thumbnail: '/images/updateLog/one_fourteen_zero.png',
    date: '2025. 07. 04. 금',
  },
  'update_1.13.0': {
    title: '1.13.0 버전 업데이트 및 변경사항',
    headline: '모바일 뷰어에서 메시지 박스 기능 지원',
    thumbnail: '/images/updateLog/one_thirteen_zero.png',
    date: '2025. 06. 10. 화',
  },
  'update_1.12.0': {
    title: '1.12.0 버전 업데이트 및 변경사항',
    headline: '플랜 배지로 현재 사용 중인 플랜을 한눈에',
    thumbnail: '/images/updateLog/one_twelve_zero.png',
    date: '2025. 06. 02. 월',
  },
  'update_1.11.0': {
    title: '1.11.0 버전 업데이트 및 변경사항',
    headline: '다국어 뷰어 지원',
    thumbnail: '/images/updateLog/one_eleven_zero.png',
    date: '2025. 05. 22. 목',
  },
  'update_1.10.0': {
    title: '1.10.0 버전 업데이트 및 변경사항',
    headline: 'PDF 색상 및 그라데이션 표현 개선',
    thumbnail: '/images/updateLog/one_ten_zero.png',
    date: '2025. 04. 29. 화',
  },
  'update_1.9.1': {
    title: '1.9.1 버전 업데이트 및 변경사항',
    headline: '보안 설정된 PDF도 업로드할 수 있어요!',
    thumbnail: '/images/updateLog/one_nine_one.png',
    date: '2025. 04. 18. 금',
  },
  'update_1.9.0': {
    title: '1.9.0 버전 업데이트 및 변경사항',
    headline: '1:1 발송용과 대량 발송용 파일이 통합되었습니다',
    thumbnail: '/images/updateLog/one_nine_zero.png',
    date: '2024. 04. 12. 금',
  },
  'update_1.8.0': {
    title: '1.8.0 버전 업데이트 및 변경사항',
    headline: '대량발송용 파일을 구글애널리틱스, 구글태그매니저에 연동',
    thumbnail: '/images/updateLog/one_eight_zero.png',
    date: '2024. 04. 11. 목',
  },
  'update_1.7.0': {
    title: '1.7.0 버전 업데이트 및 변경사항',
    headline: '뷰어가 새롭게 재단장 되었습니다.',
    thumbnail: '/images/updateLog/one_seven_zero.png',
    date: '2024. 03. 28. 목',
  },
  'update_1.6.0': {
    title: '1.6.0 버전 업데이트 및 변경사항',
    headline: '자료 일부를 ‘가림막’으로 가려 관심있는 고객 골라내기',
    thumbnail: '/images/updateLog/one_six_zero.png',
    date: '2024. 02. 29. 수',
  },
  'update_1.5.0': {
    title: '1.5.0 버전 업데이트 및 변경사항',
    headline: 'PDF 콘텐츠로 잠재 고객 이메일을 수집할 수 있어요.',
    thumbnail: '/images/updateLog/one_five_zero.png',
    date: '2023. 10. 26. 목',
  },
  'update_1.4.0': {
    title: '1.4.0 버전 업데이트 및 변경사항',
    headline: 'PDF 자료에 메시지 박스를 더해보세요!',
    thumbnail: '/images/updateLog/one_four_zero.png',
    date: '2023. 10. 10. 화',
  },
  'update_1.3.0': {
    title: '1.3.0 버전 업데이트 및 변경사항',
    headline: 'PDF 원본에 포함된 링크도 클릭 추적이 됩니다.',
    thumbnail: '/images/updateLog/one_three_zero.png',
    date: '2023. 08. 22. 화',
  },
  'update_1.2.0': {
    title: '1.2.0 버전 업데이트 및 변경사항',
    headline: '세일즈클루 링크는 그대로 두고, 파일만 교체',
    thumbnail: '/images/updateLog/one_two_zero.png',
    date: '2023. 07. 25. 화',
  },
  'update_1.1.0': {
    title: '1.1.0 버전 업데이트 및 변경사항',
    headline: '열람 기록에서 특정 IP를 제외할 수 있어요.',
    thumbnail: '/images/updateLog/one_one_zero.png',
    date: '2023. 07. 12. 월',
  },
} as const;

export const CHANGE_LOG_PAGE_SIZE = 6;

export type ChangeLogKeyType =
  | 'update_1.1.0'
  | 'update_1.2.0'
  | 'update_1.3.0'
  | 'update_1.4.0'
  | 'update_1.5.0'
  | 'update_1.6.0'
  | 'update_1.7.0'
  | 'update_1.8.0'
  | 'update_1.9.0'
  | 'update_1.9.1'
  | 'update_1.10.0'
  | 'update_1.11.0'
  | 'update_1.12.0'
  | 'update_1.13.0'
  | 'update_1.14.0'
  | 'update_1.15.0'
  | 'update_1.16.0'
  | 'update_1.17.0'
  | 'update_1.18.0'
  | 'update_1.19.0'
  | 'update_1.20.0'
  | 'update_1.21.0'
  | 'update_1.22.0'
  | 'update_1.23.0'
  | 'update_1.24.0'
  | 'update_1.25.0'
  | 'update_1.26.0'
  | 'update_1.27.0'
  | 'update_1.28.0'
  | 'update_1.29.0'
  | 'update_1.30.0'
  | 'update_1.31.0'
  | 'update_1.32.0'
  | 'update_1.33.0'
  | 'update_1.34.0'
  | 'update_1.35.0'
  | 'update_1.36.0'
  | 'update_1.37.0'
  | 'update_1.38.0'
  | 'update_1.39.0';
